import { render, staticRenderFns } from "./NotificationDetailDialog.vue?vue&type=template&id=2e6997e4&scoped=true"
import script from "./NotificationDetailDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetailDialog.vue?vue&type=style&index=0&id=2e6997e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6997e4",
  null
  
)

export default component.exports